import React, { Component } from "react";

import { withReportsHistory } from "./../../../shared/containers/containerReportsHistory";

import HistoryReportItem from "./historyReportItem";
import ScrollWrapper from "./../../../shared/items/static/scrollWrapper";
import Notification from "./../../../shared/items/static/notification";

import CookieService from "../../../shared/services/cookiesService";
import configuration from "./../../../config.json";

import "./listHistoryReports.scss";

const COUNT_ON_PAGE = 10;

class ListHistoryReports extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isReportSelected: false,
      range: 0,
    };
  }

  componentDidMount() {
    const { onSetReportsHistory, isHistoryReportReady, onSetHistoryReportNotReady } = this.props;

    const authData = JSON.parse(CookieService.getCookie(configuration.cookieName));
    const email = authData.email;
    const reportsHistory = !!localStorage.getItem(configuration.reportsHistory)
      ? JSON.parse(localStorage.getItem(configuration.reportsHistory))
      : [];
      
    const userReports = reportsHistory.find((item) => item.email === email);
    const userReportsList = userReports ? userReports.list : [];

    if (!!userReportsList) {
      onSetReportsHistory(userReportsList);
    }

    if (isHistoryReportReady) {
      onSetHistoryReportNotReady();
    }
  }

  setReportSelected() {
    this.setState({ isReportSelected: true });
  }

  onScrollBottom() {
    const { reportsHistoryData } = this.props;
    const { range } = this.state;

    if (!!reportsHistoryData && reportsHistoryData.length > range * COUNT_ON_PAGE + COUNT_ON_PAGE) {
      this.setState({ range: range + 1 });
    }
  }

  deconsteReport(index) {
    const { reportsHistoryData, onSetReportsHistory } = this.props;
    const authData = JSON.parse(CookieService.getCookie(configuration.cookieName));
    const email = authData.email;
    const reportsHistory = JSON.parse(localStorage.getItem(configuration.reportsHistory));
    const updatedHistory = [...reportsHistoryData];
    updatedHistory.splice(index, 1);
    const userHistory = reportsHistory.find((item) => item.email === email);
    const userHistoryList = userHistory.list;
    userHistoryList.splice(index, 1);

    onSetReportsHistory(updatedHistory);
    localStorage.setItem(configuration.reportsHistory, JSON.stringify(reportsHistory));
  }

  render() {
    const { reportsHistoryData } = this.props;
    const { range } = this.state;
    const reports = reportsHistoryData.slice(0, range * COUNT_ON_PAGE + COUNT_ON_PAGE);

    return (
      <ScrollWrapper height={774} onScrollBottom={this.onScrollBottom.bind(this)}>
        <div className="wrapper_reportsHistoryList">
          {reportsHistoryData.length > 0 ? (
            reports.map((item, index) => {
              return (
                <HistoryReportItem
                  data={item}
                  isReportSelected={this.state.isReportSelected}
                  setReportSelected={this.setReportSelected.bind(this)}
                  deconsteReport={this.deconsteReport.bind(this, index)}
                  key={index}
                />
              );
            })
          ) : (
            <Notification type="warning">
              <p>История отчетов отсутствует</p>
            </Notification>
          )}
        </div>
      </ScrollWrapper>
    );
  }
}

export default withReportsHistory(ListHistoryReports);
